import React from 'react';
import '../../styles/toast.css';
import type {
	AnimationType,
	Toast,
	ToastComponentProps,
	AlertType,
} from './toast-models';
import Alert from '@barracuda-internal/bds-core-v2/dist/Alert';

const getAnimationClasses = (animation: AnimationType) => {
	switch (animation) {
		case 'pop':
			return 'popIn';
		case 'slide':
			return 'slideIn';
		case 'fade':
		default:
			return 'fadeIn';
	}
};

const alertTypeToBdsType = (
	type: AlertType,
):
	| 'neutralSuccess'
	| 'neutralError'
	| 'neutralWarning'
	| 'neutralInfo'
	| 'emphasisInfo' => {
	switch (type) {
		case 'success':
			return 'neutralSuccess';
		case 'error':
			return 'neutralError';
		case 'warning':
			return 'neutralWarning';
		case 'info':
			return 'neutralInfo';
		case 'default':
		default:
			return 'emphasisInfo';
	}
};

const Toast: React.FC<Toast> = ({
	type = 'default',
	message,
	duration = 3000,
	animation = 'fade',
	fullWidth = false,
	...rest
}) => {
	const animationClass = getAnimationClasses(animation);

	return (
		<div
			className={`toast ${animationClass}`}
			style={
				{
					'--animation-duration': `${duration / 1000}s`,
					width: fullWidth ? '100%' : 'fit-content',
				} as React.CSSProperties
			}
		>
			<Alert
				sx={{ mb: 2 }}
				bdsType={alertTypeToBdsType(type)}
				bdsBoxShadowType="inline"
				{...rest}
			>
				{message}
			</Alert>
		</div>
	);
};

const ToastComponent: React.FC<ToastComponentProps> = ({
	toasts,
	position,
}) => {
	return (
		<div
			className={`toast-container ${position} ${position.split('-')[0]}`}
		>
			{toasts.map((toast) => (
				<Toast key={toast.id} {...toast} />
			))}
		</div>
	);
};

export default ToastComponent;
